<template>
  <div class="text-xl font-sans font-medium pt-8 pb-14 relative min-h-screen grey-bkg"> 
    
    <!--Introduzione-->
    <div v-show="step === 1" class="css-typing px-4">
        <p>Ecco alcune informazioni</p>
        <p>che ti aiuteranno a</p>
        <p>capire le azioni che devi</p>
        <p>mettere in campo</p>
        <p>per aprire una nuova azienda.</p>
        <p>La maggior parte delle start-up</p>
        <p>chiudono dopo poco tempo</p>
        <p>a causa di errori basilari</p>
        <p>di impostazione.</p>
        <p>Gli errori possono essere tanti,</p>
        <p>qui analizzeremo solo</p>
        <p>i più importanti</p>
        <button @click.prevent="next()" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>
    </div>

    <div v-show="step === 2">
        <div class="flex flex-col px-8 w-full">
            
            <!--1 Primo Errore: passare troppo tempo a costruire il prodotto “perfetto”-->
            <div class="flex">
            <button
            @click="step = 3"
            class="font-semibold w-full bg-transparent my-2 py-2 p-2 text-gray-800 border border-white rounded-lg shadow text-sm text-center bg-white"
            :class="{ done : active_el == 1 }"><span class="text-pink-500 font-semibold">Primo Errore:</span><br>passare troppo tempo a costruire il prodotto “perfetto”</button>
            </div>

            
            <!--2 Secondo Errore: Riempirsi di costi che poi non riuscirai a coprire-->
            <button
            v-if="active_el >= 1"
            @click="step = 8"
            class="font-semibold w-full bg-transparent my-2 py-2 px-4 text-gray-800 border border-white rounded-lg shadow text-sm text-center bg-white"
            :class="{ done : active_el_two == 2 }"><span class="text-pink-500 font-semibold">Secondo Errore:</span><br>Riempirsi di costi che poi non riuscirai a coprire</button>

            <button
            v-else
            class="font-semibold w-full bg-transparent my-2 py-2 px-4 text-white border border-white rounded-lg shadow text-sm"
            :class="{ done : active_el_two == 2 }"><span class="text-pink-500 font-semibold">Secondo Errore:</span><br>Riempirsi di costi che poi non riuscirai a coprire</button>

            <!--3 Terzo Errore: Non comprendere l’effettiva domanda-->
            <button
            v-if="active_el_two >= 2"
            @click="step = 13"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-gray-800 border-white rounded-lg shadow text-sm text-center bg-white" 
            :class="{ done : active_el_three == 3 }"><span class="text-pink-500 font-semibold">Terzo Errore:</span><br>Non comprendere l’effettiva domanda</button>

            <button
            v-else
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-white border border-white rounded-lg shadow text-sm " 
            :class="{ done : active_el_three == 3 }"><span class="text-pink-500 font-semibold">Terzo Errore:</span><br>Non comprendere l’effettiva domanda</button>

            <!--4 Quarto Errore: Non capire la Curva di una Start Up-->
            <button
            v-if="active_el_three >= 3"
            @click="step = 22"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-gray-800 border border-white rounded-lg shadow text-sm text-center bg-white" 
            :class="{ done : active_el_four == 4 }"><span class="text-pink-500 font-semibold">Quarto Errore:</span><br>Non capire la Curva di una Start Up</button>

            <button
            v-else
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-white border border-white rounded-lg shadow text-sm " 
            :class="{ done : active_el_four == 4 }"><span class="text-pink-500 font-semibold">Quarto Errore:</span><br>Non capire la Curva di una Start Up</button>


            <!--5 Quinto Errore: Aspettare troppo prima di iniziare a Vendere-->
            <button
            v-if="active_el_four >= 4"
            @click="step = 29"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-gray-800 border border-white rounded-lg shadow text-sm text-center bg-white" 
            :class="{ done : active_el_five == 5 }"><span class="text-pink-500 font-semibold">Quinto Errore:</span><br>Aspettare troppo prima di iniziare a Vendere</button>

            <button
            v-else
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-white border border-white rounded-lg shadow text-sm " 
            :class="{ done : active_el_five == 5 }"><span class="text-pink-500 font-semibold">Quinto Errore:</span><br>Aspettare troppo prima di iniziare a Vendere</button>

            <!--6 Sesto Errore: Sito Internet Magnifico Un Sacco di Soldi Bruciati-->
            <button
            v-if="active_el_five >= 5"
            @click="step = 37"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-gray-800 border border-white rounded-lg shadow text-sm text-center bg-white" 
            :class="{ done : active_el_six == 6 }"><span class="text-pink-500 font-semibold">Sesto Errore:</span><br>Sito Internet Magnifico Un Sacco di Soldi Bruciati</button>

            <button
            v-else
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-white border border-white rounded-lg shadow text-sm " 
            :class="{ done : active_el_six == 6 }"><span class="text-pink-500 font-semibold">Sesto Errore:</span><br>Sito Internet Magnifico Un Sacco di Soldi Bruciati</button>

            <!--7 Settimo Errore: Non Avere almeno uno dei Soci che è Forte nella Vendita-->
            <button
            v-if="active_el_six >= 6"
            @click="step = 40"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-gray-800 border border-white rounded-lg shadow text-sm text-center bg-white" 
            :class="{ done : active_el_seven == 7 }"><span class="text-pink-500 font-semibold">Settimo Errore:</span><br>Non Avere almeno uno dei Soci che è Forte nella Vendita</button>

            <button
            v-else
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-white border border-white rounded-lg shadow text-sm " 
            :class="{ done : active_el_seven == 7 }"><span class="text-pink-500 font-semibold">Settimo Errore:</span><br>Non Avere almeno uno dei Soci che è Forte nella Vendita</button>

            <!--8 Ottavo Errore: Non farsi seguire da un bravo Professionista-->
            <button
            v-if="active_el_seven >= 7"
            @click="step = 48"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-gray-800 border border-white rounded-lg shadow text-sm text-center bg-white" 
            :class="{ done : active_el_eight == 8 }"><span class="text-pink-500 font-semibold">Ottavo Errore:</span><br>Non farsi seguire da un bravo Professionista</button>

            <button
            v-else
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-white border border-white rounded-lg shadow text-sm " 
            :class="{ done : active_el_eight == 8 }"><span class="text-pink-500 font-semibold">Ottavo Errore:</span><br>Non farsi seguire da un bravo Professionista</button>

            <!--9 Nono Errore: fare società con le persone sbagliate-->
            <button
            v-if="active_el_eight >= 8"
            @click="step = 54"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-gray-800 border border-white rounded-lg shadow text-sm text-center bg-white" 
            :class="{ done : active_el_nine == 9 }"><span class="text-pink-500 font-semibold">Nono Errore:</span><br>fare società con le persone sbagliate</button>

            <button
            v-else
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-white border border-white rounded-lg shadow text-sm " 
            :class="{ done : active_el_nine == 9 }"><span class="text-pink-500 font-semibold">Nono Errore:</span><br>fare società con le persone sbagliate</button>

            <!--10 Decimo Errore: non capire che il cliente è il vero BOSS!-->
            <button
            v-if="active_el_nine >= 9"
            @click="step = 64"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-gray-800 border border-white rounded-lg shadow text-sm text-center bg-white" 
            ><span class="text-pink-500 font-semibold">Decimo Errore:</span><br>non capire che il cliente è il vero BOSS!</button>

            <button
            v-else
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-white border border-white rounded-lg shadow text-sm " 
            ><span class="text-pink-500 font-semibold">Decimo Errore:</span><br>non capire che il cliente è il vero BOSS!</button>

        </div>
      </div>



    <!--1 Primo Errore: passare troppo tempo a costruire il prodotto “perfetto”-->
      <div v-show="step === 3">
        <p class="px-8">
        Il dramma di molte start-up è quello di perdere tanto tempo a costruire il prodotto o servizio perfetto e poi accorgersi che non c’è mercato (o aver finito i soldi).
        </p>
        <button @click="step--" class="absolute left-10 bottom-40 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click.prevent="next()" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>
      </div>


      <div v-show="step === 4">
        <p class="px-8">
          Sappi che l’idea del prodotto o servizio che hai avuto PRIMA dell’avvio della tua impresa, verrà modificata profondamente dopo che inizi a vendere, o a provare a vendere, ai clienti.
        </p>
        <button @click="step--" class="absolute left-10 bottom-40 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step++" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>

      <div v-show="step === 5">
        <p class="px-8">Per questo motivo devi costruire un prototipo RAPIDAMENTE e poi cominciare a provare a vendere IL PRIMA POSSIBILE, altrimenti fallirai.</p>
         <button @click="step--" class="absolute left-10 bottom-40 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click.prevent="next()" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>
      </div>
 
      <div v-show="step === 6">
        <p class="px-8">
        Lo ripeto: devi provare a fare delle vendite il prima possibile, altrimenti fallirai 
        </p>
        <button @click="step--" class="absolute left-10 bottom-40 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step++" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>

      <div v-show="step === 7">
        <p class="px-8">
        Il prodotto o servizio “perfetto” è qualcosa a cui arriverai dopo che avrai venduto e erogato a diversi clienti. Fai un prototipo accettabile e inizia a promuoverlo e venderlo il prima possibile
        </p>
        <button @click="step--" class="absolute left-10 bottom-40 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step = 2, activate(1)" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>



      <!--2 Secondo Errore: Riempirsi di costi che poi non riuscirai a coprire-->
      <div v-show="step === 8">
        <p class="px-8">
        La priorità assoluta quando avvii una nuova impresa è INCASSARE SOLDI e non spenderli
        </p>
        <button @click.prevent="next()" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>
      </div>

      <div v-show="step === 9">
        <p class="px-8">
          Se quando avvii una impresa ti riempi di costi fissi e ripetitivi, poi affogherai nelle spese
        </p>
        <button @click="step--" class="absolute left-10 bottom-40 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step++" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>

      <div v-show="step === 10">
        <p class="px-8">Costi ricorrenti come: affitto degli uffici, stipendi del personale, rate per i mobili, consulenze legali, rate dell’auto nuova vanno evitati il più possibile</p>
         <button @click="step--" class="absolute left-10 bottom-40 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click.prevent="next()" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>
      </div>
 
      <div v-show="step === 11">
        <p class="px-8">
        Di fronte a ogni spesa devi chiederti: questi soldi che sto spendendo mi aiuteranno a fare una vendita nei prossimi due mesi? Se la risposta è “no”, di solito (non sempre, però) è meglio soprassedere 
        </p>
        <button @click="step--" class="absolute left-10 bottom-40 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step++" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>

      <div v-show="step === 12">
        <p class="px-8">
        Eccezioni alla regola di cui sopra possono essere i soldi che spendi per costruire il prototipo. Ma fai in fretta: prima ti metti a vendere, prima capirai come devi migliorarlo questo prototipo per far sì che piaccia ai clienti
        </p>
        <button @click="step--" class="absolute left-10 bottom-40 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step = 2,  activatetwo(2)" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>


      <!--3 Terzo Errore: Non comprendere l’effettiva domanda-->
      <div v-show="step === 13">
        <p class="px-8">
        Anche se hai avuto una buona idea, la prima cosa necessaria per aprire una nuova azienda, è aver chiaro che ci sia una richiesta per il tuo prodotto o servizio.
        </p>
        <button @click.prevent="next()" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>
      </div>

      <div v-show="step === 14">
        <p class="px-8">
          Se ti riempi di costi (o finisci i soldi) per costruire un prodotto o un servizio che poi non vuole nessuno, questo è un errore
        </p>
        <button @click="step--" class="absolute left-10 bottom-40 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step++" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>

      <div v-show="step === 15">
        <p class="px-8">Se almeno un paio di tuoi clienti (o potenziali tali) ti hanno chiesto se facevi quella cosa per loro probabilmente esiste una richiesta per quel prodotto o servizio. Se non te lo avesse chiesto nessuno e sei tu che hai deciso di lanciarti in quell’attività di tua sponte, devi provare a fare degli studi</p>
         <button @click="step--" class="absolute left-10 bottom-40 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click.prevent="next()" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>
      </div>
 
      <div v-show="step === 16">
        <p class="px-8">
        Puoi creare un sondaggio all’interno di uno o più gruppi Facebook dove sai che sono presenti dei tuoi potenziali clienti e chiedere loro in modo diretto (tramite la funzione sondaggio del social): “Questo prodotto o servizio (descrizione del tuo prodotto o servizio) ti interesserebbe?”
        </p>
        <button @click="step--" class="absolute left-10 bottom-40 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step++" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>

      <div v-show="step === 17">
        <p class="px-8">
        Potresti condurre un sondaggio a potenziali clienti che conosci mandandogli una mail con un Google Moduli o un Survey Monkey cercando di capire da loro quali sono le qualità che cercherebbero in un potenziale prodotto o servizio come il tuo
        </p>
        <button @click="step--" class="absolute left-10 bottom-40 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step++" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>

      <div v-show="step === 18">
        <p class="px-8">
        Nel fare i sondaggi, però, devi fare anche attenzione che a volte i clienti, all’inizio, non comprendono nuovi prodotti fantastici. A più di un imprenditore è capitato che i loro primi clienti dicessero: “Questa tua idea non funzionerà mai…”. Quindi usa i sondaggi con cautela.
        </p>
        <button @click="step--" class="absolute left-10 bottom-40 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step++" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>

      <div v-show="step === 19">
        <p class="px-8">
        Il miglior sondaggio che puoi fare è COMINCIARE A VENDERE IL PRIMA POSSIBILE: è in questo modo, infatti, che, scontrandoti con le richieste del cliente o del mercato, potrai capire:<br> 
        </p>
        <ul class="space-y-3 mt-3 pt-3 pb-28 px-8">
          <li class="flex space-x-3 mt-1 border-b border-gray-400 pb-2">
              <svg class="flex-shrink-0 h-4 w-4" width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.1965 7.85999C15.1965 3.71785 11.8387 0.359985 7.69653 0.359985C3.5544 0.359985 0.196533 3.71785 0.196533 7.85999C0.196533 12.0021 3.5544 15.36 7.69653 15.36C11.8387 15.36 15.1965 12.0021 15.1965 7.85999Z" fill="currentColor" class="fill-blue-500"/>
              <path d="M10.9295 4.88618C11.1083 4.67577 11.4238 4.65019 11.6343 4.82904C11.8446 5.00788 11.8702 5.32343 11.6914 5.53383L7.44139 10.5338C7.25974 10.7475 6.93787 10.77 6.72825 10.5837L4.47825 8.5837C4.27186 8.40024 4.25327 8.0842 4.43673 7.87781C4.62019 7.67142 4.93622 7.65283 5.14261 7.83629L7.01053 9.49669L10.9295 4.88618Z" fill="currentColor" class="fill-white"/>
              </svg>
              <span>che cosa davvero interessa</span>
            </li>
          <li class="flex space-x-3 mt-1 border-b border-gray-400 pb-2">
            <svg class="flex-shrink-0 h-4 w-4" width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.1965 7.85999C15.1965 3.71785 11.8387 0.359985 7.69653 0.359985C3.5544 0.359985 0.196533 3.71785 0.196533 7.85999C0.196533 12.0021 3.5544 15.36 7.69653 15.36C11.8387 15.36 15.1965 12.0021 15.1965 7.85999Z" fill="currentColor" class="fill-blue-500"/>
              <path d="M10.9295 4.88618C11.1083 4.67577 11.4238 4.65019 11.6343 4.82904C11.8446 5.00788 11.8702 5.32343 11.6914 5.53383L7.44139 10.5338C7.25974 10.7475 6.93787 10.77 6.72825 10.5837L4.47825 8.5837C4.27186 8.40024 4.25327 8.0842 4.43673 7.87781C4.62019 7.67142 4.93622 7.65283 5.14261 7.83629L7.01053 9.49669L10.9295 4.88618Z" fill="currentColor" class="fill-white"/>
              </svg>
            <span>per che cosa le persone sono disposte a spendere i loro soldi</span>
          </li>
          <li class="flex space-x-3 mt-1 border-b border-gray-400 pb-2">
            <svg class="flex-shrink-0 h-4 w-4" width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.1965 7.85999C15.1965 3.71785 11.8387 0.359985 7.69653 0.359985C3.5544 0.359985 0.196533 3.71785 0.196533 7.85999C0.196533 12.0021 3.5544 15.36 7.69653 15.36C11.8387 15.36 15.1965 12.0021 15.1965 7.85999Z" fill="currentColor" class="fill-blue-500"/>
              <path d="M10.9295 4.88618C11.1083 4.67577 11.4238 4.65019 11.6343 4.82904C11.8446 5.00788 11.8702 5.32343 11.6914 5.53383L7.44139 10.5338C7.25974 10.7475 6.93787 10.77 6.72825 10.5837L4.47825 8.5837C4.27186 8.40024 4.25327 8.0842 4.43673 7.87781C4.62019 7.67142 4.93622 7.65283 5.14261 7.83629L7.01053 9.49669L10.9295 4.88618Z" fill="currentColor" class="fill-white"/>
              </svg>
            <span>quali sono altre necessità per cui le persone sarebbero disposte a pagare ma di cui tu non ti occupi ancora</span>
          </li>
          <li class="flex space-x-3 mt-1 border-b border-gray-400 pb-2">
            <svg class="flex-shrink-0 h-4 w-4" width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.1965 7.85999C15.1965 3.71785 11.8387 0.359985 7.69653 0.359985C3.5544 0.359985 0.196533 3.71785 0.196533 7.85999C0.196533 12.0021 3.5544 15.36 7.69653 15.36C11.8387 15.36 15.1965 12.0021 15.1965 7.85999Z" fill="currentColor" class="fill-blue-500"/>
              <path d="M10.9295 4.88618C11.1083 4.67577 11.4238 4.65019 11.6343 4.82904C11.8446 5.00788 11.8702 5.32343 11.6914 5.53383L7.44139 10.5338C7.25974 10.7475 6.93787 10.77 6.72825 10.5837L4.47825 8.5837C4.27186 8.40024 4.25327 8.0842 4.43673 7.87781C4.62019 7.67142 4.93622 7.65283 5.14261 7.83629L7.01053 9.49669L10.9295 4.88618Z" fill="currentColor" class="fill-white"/>
              </svg>
            <span>le cose che ai clienti proprio non interessano</span>
          </li>
          <li class="flex space-x-3 mt-1 border-b border-gray-400 pb-2">
            <svg class="flex-shrink-0 h-4 w-4" width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.1965 7.85999C15.1965 3.71785 11.8387 0.359985 7.69653 0.359985C3.5544 0.359985 0.196533 3.71785 0.196533 7.85999C0.196533 12.0021 3.5544 15.36 7.69653 15.36C11.8387 15.36 15.1965 12.0021 15.1965 7.85999Z" fill="currentColor" class="fill-blue-500"/>
              <path d="M10.9295 4.88618C11.1083 4.67577 11.4238 4.65019 11.6343 4.82904C11.8446 5.00788 11.8702 5.32343 11.6914 5.53383L7.44139 10.5338C7.25974 10.7475 6.93787 10.77 6.72825 10.5837L4.47825 8.5837C4.27186 8.40024 4.25327 8.0842 4.43673 7.87781C4.62019 7.67142 4.93622 7.65283 5.14261 7.83629L7.01053 9.49669L10.9295 4.88618Z" fill="currentColor" class="fill-white"/>
              </svg>
            <span>cose che altri fanno GIÀ molto meglio di te e a un prezzo più basso</span>
          </li>
        </ul>
        <button @click="step--" class="absolute left-10 bottom-10 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step++" class="absolute right-10 bottom-10 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>


      <div v-show="step === 20">
        <p class="px-8">
        Il miglior sondaggio che puoi fare è COMINCIARE A VENDERE IL PRIMA POSSIBILE: è in questo modo, infatti, che, scontrandoti con le richieste del cliente o del mercato, potrai capire:<br>
        </p>
        <ul class="space-y-3 mt-3 pt-3 pb-28 px-8">
          <li class="flex space-x-3 mt-1 border-b border-gray-400 pb-2">
              <svg class="flex-shrink-0 h-4 w-4" width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.1965 7.85999C15.1965 3.71785 11.8387 0.359985 7.69653 0.359985C3.5544 0.359985 0.196533 3.71785 0.196533 7.85999C0.196533 12.0021 3.5544 15.36 7.69653 15.36C11.8387 15.36 15.1965 12.0021 15.1965 7.85999Z" fill="currentColor" class="fill-blue-500"/>
              <path d="M10.9295 4.88618C11.1083 4.67577 11.4238 4.65019 11.6343 4.82904C11.8446 5.00788 11.8702 5.32343 11.6914 5.53383L7.44139 10.5338C7.25974 10.7475 6.93787 10.77 6.72825 10.5837L4.47825 8.5837C4.27186 8.40024 4.25327 8.0842 4.43673 7.87781C4.62019 7.67142 4.93622 7.65283 5.14261 7.83629L7.01053 9.49669L10.9295 4.88618Z" fill="currentColor" class="fill-white"/>
              </svg>
              <span>che cosa davvero interessa</span>
          </li>
          <li class="flex space-x-3 mt-1 border-b border-gray-400 pb-2">
              <svg class="flex-shrink-0 h-4 w-4" width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.1965 7.85999C15.1965 3.71785 11.8387 0.359985 7.69653 0.359985C3.5544 0.359985 0.196533 3.71785 0.196533 7.85999C0.196533 12.0021 3.5544 15.36 7.69653 15.36C11.8387 15.36 15.1965 12.0021 15.1965 7.85999Z" fill="currentColor" class="fill-blue-500"/>
              <path d="M10.9295 4.88618C11.1083 4.67577 11.4238 4.65019 11.6343 4.82904C11.8446 5.00788 11.8702 5.32343 11.6914 5.53383L7.44139 10.5338C7.25974 10.7475 6.93787 10.77 6.72825 10.5837L4.47825 8.5837C4.27186 8.40024 4.25327 8.0842 4.43673 7.87781C4.62019 7.67142 4.93622 7.65283 5.14261 7.83629L7.01053 9.49669L10.9295 4.88618Z" fill="currentColor" class="fill-white"/>
              </svg>
              <span>per che cosa le persone sono disposte a spendere i loro soldi</span>
          </li>
          <li class="flex space-x-3 mt-1 border-b border-gray-400 pb-2">
              <svg class="flex-shrink-0 h-4 w-4" width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.1965 7.85999C15.1965 3.71785 11.8387 0.359985 7.69653 0.359985C3.5544 0.359985 0.196533 3.71785 0.196533 7.85999C0.196533 12.0021 3.5544 15.36 7.69653 15.36C11.8387 15.36 15.1965 12.0021 15.1965 7.85999Z" fill="currentColor" class="fill-blue-500"/>
              <path d="M10.9295 4.88618C11.1083 4.67577 11.4238 4.65019 11.6343 4.82904C11.8446 5.00788 11.8702 5.32343 11.6914 5.53383L7.44139 10.5338C7.25974 10.7475 6.93787 10.77 6.72825 10.5837L4.47825 8.5837C4.27186 8.40024 4.25327 8.0842 4.43673 7.87781C4.62019 7.67142 4.93622 7.65283 5.14261 7.83629L7.01053 9.49669L10.9295 4.88618Z" fill="currentColor" class="fill-white"/>
              </svg>
              <span>quali sono altre necessità per cui le persone sarebbero disposte a pagare ma di cui tu non ti occupi ancora</span>
          </li>
          <li class="flex space-x-3 mt-1 border-b border-gray-400 pb-2">
              <svg class="flex-shrink-0 h-4 w-4" width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.1965 7.85999C15.1965 3.71785 11.8387 0.359985 7.69653 0.359985C3.5544 0.359985 0.196533 3.71785 0.196533 7.85999C0.196533 12.0021 3.5544 15.36 7.69653 15.36C11.8387 15.36 15.1965 12.0021 15.1965 7.85999Z" fill="currentColor" class="fill-blue-500"/>
              <path d="M10.9295 4.88618C11.1083 4.67577 11.4238 4.65019 11.6343 4.82904C11.8446 5.00788 11.8702 5.32343 11.6914 5.53383L7.44139 10.5338C7.25974 10.7475 6.93787 10.77 6.72825 10.5837L4.47825 8.5837C4.27186 8.40024 4.25327 8.0842 4.43673 7.87781C4.62019 7.67142 4.93622 7.65283 5.14261 7.83629L7.01053 9.49669L10.9295 4.88618Z" fill="currentColor" class="fill-white"/>
              </svg>
              <span>le cose che ai clienti proprio non interessano</span>
          </li>
          <li class="flex space-x-3 mt-1 border-b border-gray-400 pb-2">
              <svg class="flex-shrink-0 h-4 w-4" width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.1965 7.85999C15.1965 3.71785 11.8387 0.359985 7.69653 0.359985C3.5544 0.359985 0.196533 3.71785 0.196533 7.85999C0.196533 12.0021 3.5544 15.36 7.69653 15.36C11.8387 15.36 15.1965 12.0021 15.1965 7.85999Z" fill="currentColor" class="fill-blue-500"/>
              <path d="M10.9295 4.88618C11.1083 4.67577 11.4238 4.65019 11.6343 4.82904C11.8446 5.00788 11.8702 5.32343 11.6914 5.53383L7.44139 10.5338C7.25974 10.7475 6.93787 10.77 6.72825 10.5837L4.47825 8.5837C4.27186 8.40024 4.25327 8.0842 4.43673 7.87781C4.62019 7.67142 4.93622 7.65283 5.14261 7.83629L7.01053 9.49669L10.9295 4.88618Z" fill="currentColor" class="fill-white"/>
              </svg>
              <span>cose che altri fanno GIÀ molto meglio di te e a un prezzo più basso</span>
          </li>
        </ul>
        <button @click="step--" class="absolute left-10 bottom-10 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step++" class="absolute right-10 bottom-10 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>


      <div v-show="step === 21">
        <p class="px-8">
        Sappi anche che, dopo i primi contatti con i clienti e le prime vendite, finirai sempre per modificare il tuo prodotto o servizio: comincia quindi a farlo il prima possibile: mettiti a vendere.
        </p>
        <button @click="step--" class="absolute left-10 bottom-40 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step = 2,  activatethree(3)" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>




      <!--4 Quarto Errore: Non capire la Curva di una Start Up-->
      <div v-show="step === 22">
        <img src="/img/startup-curve.png" alt="startup-curve" class="w-full mx-auto m-8 border-4 border-white">
        <p class="px-8">
        Qualsiasi nuova start-up, o progetto che avvii, seguirà l’andamento descritto in questa immagine: 
        </p>
        <p class="px-8 pb-24">Sulla parte sinistra del grafico riportiamo l’Happiness, cioè la Felicità, del fondatore dell’azienda o del responsabile del progetto. Sulla parte destra riportiamo il Tempo. Prima dello Start-Up c’è un certo livello medio di felicità o entusiasmo. Poi, subito dopo il lancio, quasi in qualsiasi progetto, c’è un grandissimo entusiasmo. Le cose vanno bene, anzi spesso sembrano anche migliori di come ce le aspettavamo.</p>

        <button @click.prevent="next()" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>
      </div>

      <div v-show="step === 23">
        <img src="/img/startup-curve.png" alt="startup-curve" class="w-full mx-auto m-8 border-4 border-white">
        <p class="px-8 pb-24">
         Poi, però, Reality Set In, cioè ti scontri con una realtà che non avevi preventivato e le cose iniziano ad andare male. Inizia il Canale della Tristezza, che nella mia esperienza dura almeno un paio d’anni. Anzi, in alcuni casi, l’impresa non ne esce proprio.  
        </p>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step++" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>

      <div v-show="step === 24">
        <img src="/img/startup-curve.png" alt="startup-curve" class="w-full mx-auto m-8 border-4 border-white">
        <p class="px-8 pb-24">
         La realtà che non avevi preventivato è che c’è qualcun altro che sta già facendo quello che volevi fare tu ma meglio, il team dei fondatori non è dei migliori, ai clienti il tuo prodotto o servizio non interessa se fatto in quel modo, ecc, ecc, ecc. Fatto sta che gestire l’azienda diventa dura. Il tono emotivo crolla e si inizia a Experimenting and Pivoting, cioè a sperimentare e a modificare un po’ la propria offerta e il proprio approccio.  
        </p>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step++" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>


      <div v-show="step === 25">
        <img src="/img/startup-curve.png" alt="startup-curve" class="w-full mx-auto m-8 border-4 border-white">
        <p class="px-8 pb-24">Le cose però funzionano, poi non funzionano, poi addirittura vanno malissimo. Iniziano poi a funzionare (Starts Working) e, dopo un po’ di tempo, si trova il Product/Market Fit cioè il modo corretto di posizionare, di costruire o di vendere, il determinato prodotto o servizio e le cose partono davvero.</p>
         <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click.prevent="next()" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>
      </div>
 
      <div v-show="step === 26">
        <img src="/img/startup-curve.png" alt="startup-curve" class="w-full mx-auto m-8 border-4 border-white">
        <p class="px-8 pb-24">
        A quel punto le cose decollano
        </p>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step++" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>

      <div v-show="step === 27">
        <p class="px-8">
        Non importa quanto figa ti sembra l’idea che hai avuto, o se fuori dalla porta hai la fila dei clienti con i soldi in mano che vorrebbero comprare, devi sempre mettere in conto che la tua idea dovrà passare dal Canale della Tristezza
        </p>
        <button @click="step--" class="absolute left-10 bottom-40 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step++" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>

      <div v-show="step === 28">
        <p class="px-8">Per gestire più efficacemente questo passaggio:</p>

        <ul class="space-y-3 mt-3 pt-3 pb-28 px-8">
          <li class="flex space-x-3 mt-1 border-b border-gray-400 pb-2">
            <svg class="flex-shrink-0 h-4 w-4" width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.1965 7.85999C15.1965 3.71785 11.8387 0.359985 7.69653 0.359985C3.5544 0.359985 0.196533 3.71785 0.196533 7.85999C0.196533 12.0021 3.5544 15.36 7.69653 15.36C11.8387 15.36 15.1965 12.0021 15.1965 7.85999Z" fill="currentColor" class="fill-blue-500"/>
              <path d="M10.9295 4.88618C11.1083 4.67577 11.4238 4.65019 11.6343 4.82904C11.8446 5.00788 11.8702 5.32343 11.6914 5.53383L7.44139 10.5338C7.25974 10.7475 6.93787 10.77 6.72825 10.5837L4.47825 8.5837C4.27186 8.40024 4.25327 8.0842 4.43673 7.87781C4.62019 7.67142 4.93622 7.65283 5.14261 7.83629L7.01053 9.49669L10.9295 4.88618Z" fill="currentColor" class="fill-white"/>
            </svg>
            <span>Pianifica in modo da non finire i soldi subito dopo il lancio</span>
          </li>
          <li class="flex space-x-3 mt-1 border-b border-gray-400 pb-2">
            <svg class="flex-shrink-0 h-4 w-4" width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.1965 7.85999C15.1965 3.71785 11.8387 0.359985 7.69653 0.359985C3.5544 0.359985 0.196533 3.71785 0.196533 7.85999C0.196533 12.0021 3.5544 15.36 7.69653 15.36C11.8387 15.36 15.1965 12.0021 15.1965 7.85999Z" fill="currentColor" class="fill-blue-500"/>
              <path d="M10.9295 4.88618C11.1083 4.67577 11.4238 4.65019 11.6343 4.82904C11.8446 5.00788 11.8702 5.32343 11.6914 5.53383L7.44139 10.5338C7.25974 10.7475 6.93787 10.77 6.72825 10.5837L4.47825 8.5837C4.27186 8.40024 4.25327 8.0842 4.43673 7.87781C4.62019 7.67142 4.93622 7.65283 5.14261 7.83629L7.01053 9.49669L10.9295 4.88618Z" fill="currentColor" class="fill-white"/>
            </svg>
            <span>Non perdere troppissimo tempo a costruire il prototipo “perfetto”</span>
          </li>
          <li class="flex space-x-3 mt-1 border-b border-gray-400 pb-2">
            <svg class="flex-shrink-0 h-4 w-4" width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.1965 7.85999C15.1965 3.71785 11.8387 0.359985 7.69653 0.359985C3.5544 0.359985 0.196533 3.71785 0.196533 7.85999C0.196533 12.0021 3.5544 15.36 7.69653 15.36C11.8387 15.36 15.1965 12.0021 15.1965 7.85999Z" fill="currentColor" class="fill-blue-500"/>
              <path d="M10.9295 4.88618C11.1083 4.67577 11.4238 4.65019 11.6343 4.82904C11.8446 5.00788 11.8702 5.32343 11.6914 5.53383L7.44139 10.5338C7.25974 10.7475 6.93787 10.77 6.72825 10.5837L4.47825 8.5837C4.27186 8.40024 4.25327 8.0842 4.43673 7.87781C4.62019 7.67142 4.93622 7.65283 5.14261 7.83629L7.01053 9.49669L10.9295 4.88618Z" fill="currentColor" class="fill-white"/>
            </svg>
            <span>Comincia a vendere il prima possibile</span>
          </li>
          <li class="flex space-x-3 mt-1 border-b border-gray-400 pb-2">
            <svg class="flex-shrink-0 h-4 w-4" width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.1965 7.85999C15.1965 3.71785 11.8387 0.359985 7.69653 0.359985C3.5544 0.359985 0.196533 3.71785 0.196533 7.85999C0.196533 12.0021 3.5544 15.36 7.69653 15.36C11.8387 15.36 15.1965 12.0021 15.1965 7.85999Z" fill="currentColor" class="fill-blue-500"/>
              <path d="M10.9295 4.88618C11.1083 4.67577 11.4238 4.65019 11.6343 4.82904C11.8446 5.00788 11.8702 5.32343 11.6914 5.53383L7.44139 10.5338C7.25974 10.7475 6.93787 10.77 6.72825 10.5837L4.47825 8.5837C4.27186 8.40024 4.25327 8.0842 4.43673 7.87781C4.62019 7.67142 4.93622 7.65283 5.14261 7.83629L7.01053 9.49669L10.9295 4.88618Z" fill="currentColor" class="fill-white"/>
            </svg>
            <span>Non farti sorprendere dai momenti duri: sappi che arriveranno, ma tu sarai forte</span>
          </li>
        </ul>
        <button @click="step--" class="absolute left-10 bottom-5 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step = 2,  activatefour(4)" class="absolute right-10 bottom-5 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>


      <!--5 Quinto Errore: Aspettare troppo prima di iniziare a Vendere-->
      <div v-show="step === 29">
        <p class="px-8">
        Non appena hai un prototipo funzionante, o che potrebbe essere portato a funzionare, tu, o uno dei tuoi soci, dovete dedicarvi con forza a provare a fare delle vendite
        </p>

        <button @click.prevent="next()" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>
      </div>

      <div v-show="step === 30">
        <p class="px-8">
         Prepara un listino prezzi o, se vendi dei servizi, una brochure descrittiva di quello che fanno i tuoi prodotti o servizi e di quanto costano
        </p>
        <button @click="step--" class="absolute left-10 bottom-40 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step++" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>

      <div v-show="step === 31">
        <p class="px-8">
         Fai una lista di tutti i potenziali clienti che conosci o che ti vengono in mente  
        </p>
        <button @click="step--" class="absolute left-10 bottom-40 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step++" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>


      <div v-show="step === 32">
        <p class="px-8">Trova altri nomi da biglietti da visita che hai archiviato, da vecchi archivi, dai social e manda loro una mail o un messaggio che accenni al valore che potresti portargli e digli che li contatterai per incontrarli</p>
         <button @click="step--" class="absolute left-10 bottom-40 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click.prevent="next()" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>
      </div>
 
      <div v-show="step === 33">
        <p class="px-8">
        Incontrane il più possibile e prova a vendere
        </p>
        <button @click="step--" class="absolute left-10 bottom-40 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step++" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>

      <div v-show="step === 34">
        <p class="px-8">
        Durante le trattative potresti anche decidere di fare un po’ di modifiche al prodotto o servizio se la cosa ti è utile per fare delle vendite
        </p>
        <button @click="step--" class="absolute left-10 bottom-40 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step++" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>

      <div v-show="step === 35">
        <p class="px-8">
        Metti in campo delle azioni di marketing per promuovere la tua attività e quello che fate:
        </p>
        
        <ul class="space-y-3 mt-3 pt-3 pb-28 px-8">
          <li class="flex space-x-3 mt-1 border-b border-gray-400 pb-2">
            <svg class="flex-shrink-0 h-4 w-4" width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.1965 7.85999C15.1965 3.71785 11.8387 0.359985 7.69653 0.359985C3.5544 0.359985 0.196533 3.71785 0.196533 7.85999C0.196533 12.0021 3.5544 15.36 7.69653 15.36C11.8387 15.36 15.1965 12.0021 15.1965 7.85999Z" fill="currentColor" class="fill-blue-500"/>
              <path d="M10.9295 4.88618C11.1083 4.67577 11.4238 4.65019 11.6343 4.82904C11.8446 5.00788 11.8702 5.32343 11.6914 5.53383L7.44139 10.5338C7.25974 10.7475 6.93787 10.77 6.72825 10.5837L4.47825 8.5837C4.27186 8.40024 4.25327 8.0842 4.43673 7.87781C4.62019 7.67142 4.93622 7.65283 5.14261 7.83629L7.01053 9.49669L10.9295 4.88618Z" fill="currentColor" class="fill-white"/>
            </svg>
            <span>Sito internet (in questa fase è solo un luogo che le persone usano per capire che la tua è una vera impresa. All’inizio il sito web non vende NIENTE. Tienilo più basico possibile)</span>
          </li>
          <li class="flex space-x-3 mt-1 border-b border-gray-400 pb-2">
            <svg class="flex-shrink-0 h-4 w-4" width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.1965 7.85999C15.1965 3.71785 11.8387 0.359985 7.69653 0.359985C3.5544 0.359985 0.196533 3.71785 0.196533 7.85999C0.196533 12.0021 3.5544 15.36 7.69653 15.36C11.8387 15.36 15.1965 12.0021 15.1965 7.85999Z" fill="currentColor" class="fill-blue-500"/>
              <path d="M10.9295 4.88618C11.1083 4.67577 11.4238 4.65019 11.6343 4.82904C11.8446 5.00788 11.8702 5.32343 11.6914 5.53383L7.44139 10.5338C7.25974 10.7475 6.93787 10.77 6.72825 10.5837L4.47825 8.5837C4.27186 8.40024 4.25327 8.0842 4.43673 7.87781C4.62019 7.67142 4.93622 7.65283 5.14261 7.83629L7.01053 9.49669L10.9295 4.88618Z" fill="currentColor" class="fill-white"/>
            </svg>
            <span>Post e articoli regolari sui tuoi social e su quelli dei tuoi soci</span>
          </li>
          <li class="flex space-x-3 mt-1 border-b border-gray-400 pb-2">
            <svg class="flex-shrink-0 h-4 w-4" width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.1965 7.85999C15.1965 3.71785 11.8387 0.359985 7.69653 0.359985C3.5544 0.359985 0.196533 3.71785 0.196533 7.85999C0.196533 12.0021 3.5544 15.36 7.69653 15.36C11.8387 15.36 15.1965 12.0021 15.1965 7.85999Z" fill="currentColor" class="fill-blue-500"/>
              <path d="M10.9295 4.88618C11.1083 4.67577 11.4238 4.65019 11.6343 4.82904C11.8446 5.00788 11.8702 5.32343 11.6914 5.53383L7.44139 10.5338C7.25974 10.7475 6.93787 10.77 6.72825 10.5837L4.47825 8.5837C4.27186 8.40024 4.25327 8.0842 4.43673 7.87781C4.62019 7.67142 4.93622 7.65283 5.14261 7.83629L7.01053 9.49669L10.9295 4.88618Z" fill="currentColor" class="fill-white"/>
            </svg>
            <span>Sponsorizzate sui social</span>
          </li>
          <li class="flex space-x-3 mt-1 border-b border-gray-400 pb-2">
            <svg class="flex-shrink-0 h-4 w-4" width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.1965 7.85999C15.1965 3.71785 11.8387 0.359985 7.69653 0.359985C3.5544 0.359985 0.196533 3.71785 0.196533 7.85999C0.196533 12.0021 3.5544 15.36 7.69653 15.36C11.8387 15.36 15.1965 12.0021 15.1965 7.85999Z" fill="currentColor" class="fill-blue-500"/>
              <path d="M10.9295 4.88618C11.1083 4.67577 11.4238 4.65019 11.6343 4.82904C11.8446 5.00788 11.8702 5.32343 11.6914 5.53383L7.44139 10.5338C7.25974 10.7475 6.93787 10.77 6.72825 10.5837L4.47825 8.5837C4.27186 8.40024 4.25327 8.0842 4.43673 7.87781C4.62019 7.67142 4.93622 7.65283 5.14261 7.83629L7.01053 9.49669L10.9295 4.88618Z" fill="currentColor" class="fill-white"/>
            </svg>
            <span>Mail personali a tuoi vecchi clienti e contatti</span>
          </li>
          <li class="flex space-x-3 mt-1 border-b border-gray-400 pb-2">
            <svg class="flex-shrink-0 h-4 w-4" width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.1965 7.85999C15.1965 3.71785 11.8387 0.359985 7.69653 0.359985C3.5544 0.359985 0.196533 3.71785 0.196533 7.85999C0.196533 12.0021 3.5544 15.36 7.69653 15.36C11.8387 15.36 15.1965 12.0021 15.1965 7.85999Z" fill="currentColor" class="fill-blue-500"/>
              <path d="M10.9295 4.88618C11.1083 4.67577 11.4238 4.65019 11.6343 4.82904C11.8446 5.00788 11.8702 5.32343 11.6914 5.53383L7.44139 10.5338C7.25974 10.7475 6.93787 10.77 6.72825 10.5837L4.47825 8.5837C4.27186 8.40024 4.25327 8.0842 4.43673 7.87781C4.62019 7.67142 4.93622 7.65283 5.14261 7.83629L7.01053 9.49669L10.9295 4.88618Z" fill="currentColor" class="fill-white"/>
            </svg>
            <span>Volantini</span>
          </li> 
          <li class="flex space-x-3 mt-1 border-b border-gray-400 pb-2">
            <svg class="flex-shrink-0 h-4 w-4" width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.1965 7.85999C15.1965 3.71785 11.8387 0.359985 7.69653 0.359985C3.5544 0.359985 0.196533 3.71785 0.196533 7.85999C0.196533 12.0021 3.5544 15.36 7.69653 15.36C11.8387 15.36 15.1965 12.0021 15.1965 7.85999Z" fill="currentColor" class="fill-blue-500"/>
              <path d="M10.9295 4.88618C11.1083 4.67577 11.4238 4.65019 11.6343 4.82904C11.8446 5.00788 11.8702 5.32343 11.6914 5.53383L7.44139 10.5338C7.25974 10.7475 6.93787 10.77 6.72825 10.5837L4.47825 8.5837C4.27186 8.40024 4.25327 8.0842 4.43673 7.87781C4.62019 7.67142 4.93622 7.65283 5.14261 7.83629L7.01053 9.49669L10.9295 4.88618Z" fill="currentColor" class="fill-white"/>
            </svg>
            <span>Eventi low cost</span>
          </li>
          <li class="flex space-x-3 mt-1 border-b border-gray-400 pb-2">
            <svg class="flex-shrink-0 h-4 w-4" width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.1965 7.85999C15.1965 3.71785 11.8387 0.359985 7.69653 0.359985C3.5544 0.359985 0.196533 3.71785 0.196533 7.85999C0.196533 12.0021 3.5544 15.36 7.69653 15.36C11.8387 15.36 15.1965 12.0021 15.1965 7.85999Z" fill="currentColor" class="fill-blue-500"/>
              <path d="M10.9295 4.88618C11.1083 4.67577 11.4238 4.65019 11.6343 4.82904C11.8446 5.00788 11.8702 5.32343 11.6914 5.53383L7.44139 10.5338C7.25974 10.7475 6.93787 10.77 6.72825 10.5837L4.47825 8.5837C4.27186 8.40024 4.25327 8.0842 4.43673 7.87781C4.62019 7.67142 4.93622 7.65283 5.14261 7.83629L7.01053 9.49669L10.9295 4.88618Z" fill="currentColor" class="fill-white"/>
            </svg>
            <span>Più rumore fai meglio è ma ricordati che se fai solo promozione e non visiti nessuno, venderai zero</span>
          </li>
        </ul>
        
        <button @click="step--" class="absolute left-10 bottom-5 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step++" class="absolute right-10 bottom-5 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>

      <div v-show="step === 36">
        <p class="px-8">
        Se puoi assumi o, ancora meglio coinvolgi come socio, qualcuno che può farti fare molto vendite
        </p>
        <button @click="step--" class="absolute left-10 bottom-40 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step = 2,  activatefive(5)" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>


      <!--6 Sesto Errore: Sito Internet Magnifico Un Sacco di Soldi Bruciati-->
      <div v-show="step === 37">
        <p class="px-8">
        Bruciare un sacco di liquidità per costruire un sito internet fantastico sin dall’inizio è un errore che dovresti evitare
        </p>

        <button @click.prevent="next()" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>
      </div>

      <div v-show="step === 38">
        <p class="px-8">
         Un sito vale nella misura in cui è visitato da potenziali clienti e quindi: o sei un mago nel SEO, o hai un sacco di soldi da spendere su Google Ads, altrimenti il tuo fantastico sito per mesi non verrà visitato da nessuno.
        </p>
        <button @click="step--" class="absolute left-10 bottom-40 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step++" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>

      <div v-show="step === 39">
        <p class="px-8">
         Meglio costruire un sito basic e una bellissima landing page e poi investire il resto per avere dei veri contatti o lead
        </p>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step = 2,  activatesix(6)" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>


      <!--7 Settimo Errore: Non Avere almeno uno dei Soci che è Forte nella Vendita-->
      <div v-show="step === 40">
        <p class="px-8">
        Una buona parte del successo dell’azienda dipenderà dalla sua capacità di vendita.
        </p>

        <button @click.prevent="next()" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>
      </div>

      <div v-show="step === 41">
        <p class="px-8">
        Se tu o uno dei soci non siete forti nel marketing o nelle vendite, è opportuno che tu corra ai ripari coinvolgendo un altro fondatore o formandoti tu
        </p>
        <button @click="step--" class="absolute left-10 bottom-40 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step++" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>

      <div v-show="step === 42">
        <p class="px-8">
         Puoi cominciare a formarti low cost sulle vendite facendo il programma apposito all’interno di questa app
        </p>
        <button @click="step--" class="absolute left-10 bottom-40 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step++" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>

      <div v-show="step === 43">
        <p class="px-8">Se ancora non l’avessi fatto, potresti sottoporti all’Analisi I-Profile per capire le tue aree di miglioramento. Puoi farlo anche gratuitamente se accumuli abbastanza OSM COIN formandoti in questa App</p>
         <button @click="step--" class="absolute left-10 bottom-40 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click.prevent="next()" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>
      </div>
 
      <div v-show="step === 44">
        <p class="px-8">
        Potresti guadagnare un po’ di OSM COIN e formarti con la APP I-OSM che include molti programmi di vendita
        </p>
        <button @click="step--" class="absolute left-10 bottom-40 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step++" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>

      <div v-show="step === 45">
        <p class="px-8">
        Oppure potresti partecipare a uno dei tanti corsi di valore sull’argomento offerti dai nostri colleghi
        </p>
        <button @click="step--" class="absolute left-10 bottom-40 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step++" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>

      <div v-show="step === 46">
        <p class="px-8">
        La Onlus Imprenditore Non Sei Solo offre un programma di formazione in presenza completamente gratuito per chi ha deciso di avviare una start-up<br><a href="https://imprenditorenonseisolo.it/startup/" target="blank" class="underline">imprenditorenonseisolo</a>
        </p>
        <button @click="step--" class="absolute left-10 bottom-40 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step++" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>

      <div v-show="step === 47">
        <p class="px-8">
        Se non hai nessuno forte nelle vendite alla cima dell’azienda sarai sempre alla mercé del mercato o dei tuoi venditori
        </p>
        <button @click="step--" class="absolute left-10 bottom-40 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step = 2,  activateseven(7)" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>


      <!--8 Ottavo Errore: Non farsi seguire da un bravo Professionista-->
      <div v-show="step === 48">
        <p class="px-8">
        Il Professionista dell’azienda è il commercialista, o a volte il legale. Il commercialista ti aiuterà a impostare correttamente la tua società e a pagare il giusto livello di tasse.
        </p>

        <button @click.prevent="next()" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>
      </div>

      <div v-show="step === 49">
        <p class="px-8">
        Se non ti affidi a un bravo commercialista è quasi certo che tu finirai per pagare molte più tasse di quelle che sarebbero legalmente dovute
        </p>
        <button @click="step--" class="absolute left-10 bottom-40 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step++" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>

      <div v-show="step === 50">
        <p class="px-8">
         Questo è dovuto alla complessità del sistema fiscale italiano e alla pigrizia di alcuni professionisti.
        </p>
        <button @click="step--" class="absolute left-10 bottom-40 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step++" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>

      <div v-show="step === 51">
        <p class="px-8">Il commercialista ti aiuterà anche nello stabilire come inquadrare in base alla Legge le prime persone che assumerai</p>
         <button @click="step--" class="absolute left-10 bottom-40 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click.prevent="next()" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>
      </div>
 
      <div v-show="step === 52">
        <p class="px-8">
        Il legale potrebbe esserti utile per pareri un po’ più tecnici come la stesura di alcuni contratti o la protezione del tuo marchio o del tuo know how. Ti consigliamo di negoziare un contratto, inizialmente da poche centinaia di euro al mese, con un legale esperto d’impresa che ti segua nella tua start-up
        </p>
        <button @click="step--" class="absolute left-10 bottom-40 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step++" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>

      <div v-show="step === 53">
        <p class="px-8">
        Noi consigliamo di affidarsi a Commercialisti o a Legali affiliati al network di Partner d’Impresa  www.partnerdimpresa.it in quanto praticano lo scambio in abbondanza.
        </p>
        <button @click="step--" class="absolute left-10 bottom-40 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step = 2,  activateeight(8)" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>



      <!--9 Nono Errore: fare società con le persone sbagliate-->
      <div v-show="step === 54">
        <p class="px-8">
        La regola più importante del business è PRIMA CHI E POI CHE COSA!
        </p>

        <button @click.prevent="next()" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>
      </div>

      <div v-show="step === 55">
        <p class="px-8">
        Il valore di un’idea imprenditoriale (la tua) è direttamente proporzionale alla qualità delle persone che l’hanno sposata: se fai società con persone demotivate, critiche, rigide o che non hanno un certo entusiasmo, anche se competenti, alla lunga potrebbero convincerti che la tua idea non funzionerà.
        </p>
        <button @click="step--" class="absolute left-10 bottom-40 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step++" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>

      <div v-show="step === 56">
        <p class="px-8">
         Se fai società con persone piene di energia positiva, con ottimi rapporti interpersonali, e che si accendono facilmente, è molto più facile che la tua idea si affermi sul mercato.
        </p>
        <button @click="step--" class="absolute left-10 bottom-40 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step++" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>

      <div v-show="step === 57">
        <p class="px-8">I disaccordi al vertice sono una delle prime ragioni per cui un’azienda smette di funzionare e poi si blocca</p>
         <button @click="step--" class="absolute left-10 bottom-40 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click.prevent="next()" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>
      </div>
 
      <div v-show="step === 58">
        <p class="px-8">
        Tu e il tuo socio, o il tuo potenziale socio, condividete gli stessi valori? 
        </p>
        <div class="flex flex-col mt-4 p-8 w-full">
          <button
            @click="step++"
            class="font-semibold w-full bg-transparent my-2 py-2 px-4 text-white border border-white rounded-full shadow"
          >
            Sì
          </button>
          <button
            @click="step++"
            class="font-semibold w-full bg-transparent my-2 py-2 px-4 text-white border border-white rounded-full shadow"
          >
            No
          </button>
        </div>
        <button @click="step--" class="absolute left-10 bottom-40 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
      </div>

      <div v-show="step === 59">
        <p class="px-8">
        Uno di voi due possiede buone capacità commerciali?
        </p>
        <div class="flex flex-col mt-4 p-8 w-full">
          <button
            @click="step++"
            class="font-semibold w-full bg-transparent my-2 py-2 px-4 text-white border border-white rounded-full shadow"
          >
            Sì
          </button>
          <button
            @click="step++"
            class="font-semibold w-full bg-transparent my-2 py-2 px-4 text-white border border-white rounded-full shadow"
          >
            No
          </button>
        </div>
        <button @click="step--" class="absolute left-10 bottom-40 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
      </div>

      <div v-show="step === 60">
        <p class="px-8">
        Se hai scelto un socio finanziatore, questa persona si limita a mettere i soldi o ti darà anche una mano nella gestione dell’attività?
        </p>
        <div class="flex flex-col mt-4 p-8 w-full">
          <button
            @click="step++"
            class="font-semibold w-full bg-transparent my-2 py-2 px-4 text-white border border-white rounded-full shadow"
          >
            Sì
          </button>
          <button
            @click="step++"
            class="font-semibold w-full bg-transparent my-2 py-2 px-4 text-white border border-white rounded-full shadow"
          >
            No
          </button>
        </div>
        <button @click="step--" class="absolute left-10 bottom-40 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
      </div>

      <div v-show="step === 61">
        <p class="px-8">
        Tu e il tuo socio andate molto d’accordo e siete spesso sulla stessa lunghezza d’onda riguardo alle cose da fare?
        </p>
        <div class="flex flex-col mt-4 p-8 w-full">
          <button
            @click="step++"
            class="font-semibold w-full bg-transparent my-2 py-2 px-4 text-white border border-white rounded-full shadow"
          >
            Sì
          </button>
          <button
            @click="step++"
            class="font-semibold w-full bg-transparent my-2 py-2 px-4 text-white border border-white rounded-full shadow"
          >
            No
          </button>
        </div>
        <button @click="step--" class="absolute left-10 bottom-40 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
      </div>

      <div v-show="step === 62">
        <p class="px-8">
        Il tuo socio è una persona ha un comportamento cristallino sotto il piano etico?
        </p>
        <div class="flex flex-col mt-4 p-8 w-full">
          <button
            @click="step++"
            class="font-semibold w-full bg-transparent my-2 py-2 px-4 text-white border border-white rounded-full shadow"
          >
            Sì
          </button>
          <button
            @click="step++"
            class="font-semibold w-full bg-transparent my-2 py-2 px-4 text-white border border-white rounded-full shadow"
          >
            No
          </button>
        </div>
        <button @click="step--" class="absolute left-10 bottom-40 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
      </div>

      <div v-show="step === 63">
        <p class="px-8">
        Se una o più delle domande di cui sopra avessero una risposta negativa, dovresti cercare di approfondire la questione PRIMA di costituire la società!  
        </p>
        <button @click="step--" class="absolute left-10 bottom-40 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step = 2,  activatenine(9)" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>

      <!--10 Decimo Errore: non capire che il cliente è il vero BOSS!-->
      <div v-show="step === 64">
        <p class="px-8">
        Un’azienda esiste non per far diventare ricchi i suoi fondatori o soddisfare il loro ego 
        </p>

        <button @click="step++" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>

      <div v-show="step === 65">
        <p class="px-8">
        Esiste UNICAMENTE per risolvere i problemi o le difficoltà dei clienti. Oppure per far vivere loro delle BELLE esperienze. Oppure per creare valore per chi si serve dei suoi prodotti o servizi  
        </p>
        <button @click="step--" class="absolute left-10 bottom-40 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step++" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>

      <div v-show="step === 66">
        <p class="px-8">
        La tua ricchezza comincia con un cliente che aiuti a realizzare i suoi sogni. La tua povertà comincia con un cliente che smette di chiamarti  
        </p>
        <button @click="step--" class="absolute left-10 bottom-40 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step++" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>

      <div v-show="step === 67"> 
        <p class="px-8">
        Qualsiasi cosa tu faccia, cerca di non perdere mai dei clienti 
        </p>     
        <button @click="step--" class="absolute left-10 bottom-40 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click.prevent="next(), isComplete = true" class="absolute right-10 bottom-40 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>
 

    <div v-if="isComplete == true && done[11] == 0" class="mx-8">
      <form @submit.prevent="submit">
      <audio autoplay>
        <source src="/sound/money.wav" type="audio/wav" />
      </audio>
      <ul class="flex flex-wrap justify-center">
        <li class="w-1/6">
          <img src="/img/osm-coin.png" alt="gem" />
        </li>
      </ul>
      <p class="p-8 text-center text-2xl text-white font-bold">
        Complimenti! Hai terminato questo percorso della APP!!!<br>
        Ti abbiamo assegnato 3 OSMC !!!”
      </p>
      <button
          type="submit"
          class="font-semibold w-full  bg-transparent my-2  py-2 px-4 text-white border border-white rounded-full shadow"
        >
          fine
        </button>
      </form>
    </div>

    <div v-if="isComplete == true && done[11] == 1" class="p-8">
      <h5 class="text-left text-2xl text-white font-bold">
        Complimenti!<br />Hai compleatato nuovamente questo percorso della APP!!!<br />
      </h5>
      <inertia-link :href="route('curricula')" class="inline-block text-white py-2 px-6 border-2 border-white rounded-xl mt-16">
        fine
      </inertia-link>
    </div>

    
  </div>
</template>

<script>
export default {
   props: ['done'],
  data() {
    return {
      step: 1,
      progress: 0,
      isComplete: false,
      active_el: 0,
      active_el_two: 0,
      active_el_three: 0,
      active_el_four: 0,
      active_el_five: 0,
      active_el_six: 0,
      active_el_seven: 0,
      active_el_eight: 0,
      active_el_nine: 0,
      program_id: 12,
    };
  },
  methods: {
    prev() {
      this.step--;
      var stepValue = 10;
      this.progress = this.progress - stepValue;
    },
    next(progress) {
      this.step++;
      var stepValue = 10;
      this.progress = this.progress + stepValue;
    },
    activate:function(el){
        this.active_el = el;
    },
    activatetwo:function(el){
        this.active_el_two = el;
    },
    activatethree:function(el){
        this.active_el_three = el;
    },
    activatefour:function(el){
        this.active_el_four = el;
    },
    activatefive:function(el){
        this.active_el_five = el;
    },
    activatesix:function(el){
        this.active_el_six = el;
    },
    activateseven:function(el){
        this.active_el_seven = el;
    },
    activateeight:function(el){
        this.active_el_eight = el;
    },
    activatenine:function(el){
        this.active_el_nine = el;
    },
    submit() {
      const data = new FormData()
      data.append('program_id', this.program_id)

      this.$inertia.post(this.route('workout.store'), data, {
        onStart: () => this.sending = true,
        onFinish: () => this.sending = false,
      })
    },
  },
};
</script>

<style scoped>
.done {
  background:#73f1b8;
  color: #1f2836;
  font-weight:bold;
}

p, li {
  color: #fff;
  font-family: monospace;
  letter-spacing: .15em; /* Adjust as needed */
  font-family: 'Source Code Pro', monospace;  
  font-size: 18px;
  color: rgba(255,255,255);
}

.grey-bkg {
  background-color: #485461;
background-image: linear-gradient(315deg, #485461 0%, #28313b 74%);
}

</style>